/*
 * Application Insights JavaScript SDK - Core, 3.3.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map